const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M8 2.5h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2m9.5 8.5 2.5 1.5v-8h-5v8z" clip-rule="evenodd"/><path d="M2 6.5h2v14h14v2H4c-1.1 0-2-.9-2-2z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>';
export {
  l as default
};
